import Vue from "vue";
import CustomFieldPreview from '@shared/partials/CustomFieldPreview.vue'
import FieldTypeModal from '@shared/partials/CustomFieldModal.vue'
const partials = {
  //Custom Fields
  CustomFieldPreview,
  FieldTypeModal
}

// actions
import LoadingBar from '@shared/components/loading-bar'
import Message from '@shared/components/message'
import Http from '@shared/lib/Http'
import Master from "@shared/lib/Master"

const actions = {
	LoadingBar,
	Message,
    Http,
    Master
}

function install(Vue) {
	if(install.installed) return

	for(const partial in partials) {
		if(partials[partial].name) {
			Vue.component(partials[partial].name, partials[partial])
		}
	}

	Vue.prototype.$bar = LoadingBar
	Vue.prototype.$message = Message
    Vue.prototype.$tenant = Http
    Vue.prototype.$master = Master
    Vue.prototype.$admin = Master

}

if(typeof window !== 'undefined' && window.Vue) {
	install(window.Vue)
}

Vue.use(partials);

export default {
	install,
	...partials,
	...actions
}
